import requests from './httpService';

const readUserDetails = () => {
  try {
    const raw = localStorage.getItem("userDetail");
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (err) {
    return {};
  }
};

const ActivityService = {
  getAllActivity(id) {
    return requests.get(`/activity/list/${id}`);
  },
  getAllSuperActivity(id) {
    return requests.get(`/superactivity/list/${id}`);
  },
//   upadeCity(body) {
//     return requests.put(`/city/${body.id}`,body); 
//   },
 getStudentActivityPerformance(body){
    return requests.post(`/activity/performance`, body);

  },
  getUnmasteredActivities(body){
    return requests.post(`/activity/unmastered-activities`, body);
  },
  listAdminPublishNotifications() {
    const userDetails = readUserDetails();
    const schooleId = userDetails?.schooleId?._id || userDetails?.schooleId || userDetails?.schoolId?._id || userDetails?.schoolId;
    return requests.get(`/activity/admin-publish-notifications?role=SCHOOLE&schooleId=${schooleId}`);
  },
  approvePublish(notificationId) {
    const userDetails = readUserDetails();
    const schooleId = userDetails?.schooleId?._id || userDetails?.schooleId || userDetails?.schoolId?._id || userDetails?.schoolId;
    return requests.post(`/activity/publish-approve?role=SCHOOLE`, { notificationId, schooleId });
  },
  creteActivity(body){
    return requests.post('/activity/add',body); 
  },
  creteMultipleActivity(body){
    return requests.post('/activity/multiple-add',body); 
  },
  checkDuplicateActivities(body) {
    return requests.post('/activity/check-duplicates', body);
  },
  getExistingActivityKeys(body) {
    return requests.post('/activity/existing-keys', body);
  },
  deleteActivity(body){
    return requests.delete(`/activity/${body}`); 
    
  },
  deleteActivitiesBulk(ids) {
    return requests.post('/activity/delete-bulk', { ids });
  },
getActivityAnalysisByClass(body){
    return requests.post(`/activity/activity-analysis`,body); 

},



  findActivityList(body){
    return requests.post(`/activity/find`,body); 
  },
  getStudentActivityRecords(body) {
    return requests.post('/activity/student-records', body);
  },
  addQuickActivityRecord(body) {
    return requests.post('/activity/quick-add-record', body);
  },
  
    findActivityReports(body){
    return requests.post(`/activity/reports`,body); 
  },
      findActivityAnalysisReportsList(body){
    return requests.post(`/activity/analysis`,body); 
  },
//   getAllCoupon() {
//     return requests.get('/coupon');
//   },
getAllAddClass() {
  return requests.get('/addclass');
},

  upadeActivity(body) {
    return requests.put(`/activity/${body._id}`,body); 
  },
  patchActivityRecord(body) {
    return requests.put(`/activity/record/${body._id}`, body);
  },
   upadePublicStatus(body) {
    return requests.put(`/activity/publicstatus/${body._id}`,body); 
  },
//   const updateActivityStatus = (data) => {
//   return axios.post(`${BASE_URL}/activity/updateActivityStatus`, data);
// };
   updateActivityStatus(body) {
    return requests.put(`/activity/update-status`,body); 
  },
//   creteCoupon(body){
//     return requests.post('/coupon/add',body); 
//   },
//   deleteCoupon(body){
//     return requests.delete(`/coupon/${body._id}`); 
//   },
//   createVendorOrdersById(body){
//     return requests.post('/orders/getvendororders',body); 
//   },

//   getAllVendorList() {
//     return requests.get('/vendorlist');
//   },
userPermitions(){
  const userDetails = readUserDetails();
  switch (userDetails?.role) {
    case 'SCHOOLE':
      return {
        studentDetailsEdit: true,
        studentDetailsDelete: true,
        // studentActivityEdit:true, studentActivityDelete:true
      };
    case 'TEACHER':
      return {
        studentDetailsEdit: false,
        studentDetailsDelete: false,
        studentActivityEdit: false,
        studentActivityDelete: false,
      };
    case 'PARENT':
      return { ageEdit: false };
    case 'SUPERADMIN':
      return {
        studentDetailsEdit: true,
        studentDetailsDelete: true,
        studentActivityEdit: true,
        studentActivityDelete: true,
      };
    default:
      return {
        studentDetailsEdit: false,
        studentDetailsDelete: false,
        studentActivityEdit: false,
        studentActivityDelete: false,
      };
  }
}
};




export default ActivityService;
